import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
//
//
//
//
//
//

var PcApp = function PcApp() {
  return import('src/pc/App.vue');
};
var MobileApp = function MobileApp() {
  return import('src/mobile/App.vue');
};
export default {
  name: 'App',
  components: {
    PcApp: PcApp,
    MobileApp: MobileApp
  },
  data: function data() {
    return {
      show: true,
      isPC: process.env.BUILD_TARGET === 'pc'
    };
  },
  created: function created() {
    window.vm = this;
    this.$store.dispatch('callGNB');
    this.checkAllowed();
  },
  mounted: function mounted() {
    // this.viewWebview()
  },
  computed: {
    currentComponent: function currentComponent() {
      return this.isPC ? 'PcApp' : 'MobileApp';
    }
  },
  methods: {
    checkAllowed: function checkAllowed() {
      var _this = this;
      var random = Math.random().toString().replace(".", "");
      this.$axios.get("/check/allowed?".concat(random)).then(function (rs) {
        if (rs.status === 200) _this.show = rs.data;
      });
    },
    viewWebview: function viewWebview() {
      var ua = navigator.userAgent || '';
      var isWebView = /NAVER|KAKAOTALK|Line|FBAV|WebView/i.test(ua);
      if (isWebView) {
        var d = document.createElement('div');
        d.style.position = 'fixed';
        d.style.bottom = '0';
        d.style.left = '0';
        d.style.right = '0';
        d.style.zIndex = 9999;
        d.style.background = '#ff0';
        d.style.color = '#000';
        d.style.fontSize = '12px';
        d.style.padding = '4px';
        d.innerText = '📱 WebView Detected: ' + ua;
        document.body.insertBefore(d, document.body.firstChild);
      }
    }
  }
};